<template>
    <div>
        <section class="q10__jumbotron">
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.oImage1.src,
                    descriptions: [
                        {
                            text: currentPage.images.oImage1.alt,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                        {
                            text: currentPage.images.oImage1.text,
                            position: 'bottom-left', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-allports',
                        to: 'to-resolution_blue',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.text"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.sArticleDescription.text"
                ></p>

                <div class="container-components mb-4 lg:mb-8">
                    <TitleParagraph
                        :options="{
                            from: 'from-allports',
                            to: 'to-resolution_blue',
                        }"
                    >
                        <p
                            class="text-xl lg:text-2xl 2xl:text-4xl"
                            v-html="currentPage.content.sSubTitleOne.text"
                        ></p>
                    </TitleParagraph>
                    <div class="card">
                        <div
                            class="q10__article_container__content__paragraphs"
                        >
                            <template
                                v-for="(paragraph, idx_paragraph) in currentPage
                                    .content.sParagraphOne_Content.text"
                            >
                                <template v-if="idx_paragraph === 0">
                                    <paragraph-first-letter-big
                                        class="relative -left-1"
                                        :options="{
                                            letter: paragraph.substr(0, 1),
                                            color: 'text-allports',
                                        }"
                                    />

                                    <paragraph :options="{}">
                                        <span
                                            v-html="paragraph.slice(1)"
                                        ></span>
                                    </paragraph>
                                </template>
                            </template>
                        </div>
                    </div>
                    <div class="card">
                        <div class="break-inside-avoid">
                            <div>
                                <div class="relative">
                                    <hotspot-richmedia
                                         :options="{
                                                icon: 'diaporama',
                                                collection: getRichmediaByCollection(
                                                    currentPage,
                                                    'Remerciements DPN'
                                                ),
                                            }"
                                        class="top-2 right-2"
                                    />
                                </div>
                                <image-with-descriptions
                                    class="eliminate-margin"
                                    :options="{
                                        image:
                                            'pages/' +
                                            currentPage.slug +
                                            '/' +
                                            currentPage.images.oImage2.src,
                                        descriptions: [
                                            {
                                                text: currentPage.images.oImage2
                                                    .edf,
                                                position: 'bottom-right', // top/bottom-left/right
                                                orientation: 'horizontal', // vertical, horizontal
                                            },
                                        ],
                                    }"
                                />
                            </div>
                            <TitleParagraph
                                :options="{
                                    from: 'from-resolution_blue',
                                    to: 'to-allports',
                                }"
                            >
                                <Triangles
                                    :options="{
                                        colors: [
                                            '#0e498a',
                                            '#064e8d',
                                            '#0264a7',
                                        ],
                                        direction: 'top',
                                    }"
                                />
                                <span
                                    class="font-bold"
                                    v-html="
                                        currentPage.content.sParagraphTwo_Title
                                            .text
                                    "
                                ></span>
                            </TitleParagraph>
                        </div>

                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphTwo_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card">
                        <div class="break-inside-avoid">
                            <image-with-descriptions
                                class="eliminate-margin"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage3.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage3
                                                .alt,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.oImage3
                                                .text,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                            <TitleParagraph
                                :options="{
                                    from: 'from-resolution_blue',
                                    to: 'to-allports',
                                }"
                            >
                                <Triangles
                                    :options="{
                                        colors: [
                                            '#0e498a',
                                            '#064e8d',
                                            '#0264a7',
                                        ],
                                        direction: 'top',
                                    }"
                                />
                                <span
                                    v-html="
                                        currentPage.content
                                            .sParagraphThree_Title.text
                                    "
                                ></span>
                            </TitleParagraph>
                        </div>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                class="text-nandor 2xl:text-lg"
                                v-html="
                                    currentPage.content.sParagraphThree_Content
                                        .text
                                "
                            >
                            </span>
                            <Dots
                                :options="{
                                    colors: ['#0e498a', '#064e8d', '#0264a7'],
                                }"
                            />
                        </paragraph>
                    </div>
                </div>
                <div class="card relative mb-4 lg:mb-8">
                    <div class="relative w-full h-full">
                        <image-with-descriptions
                            :options="{
                                imageFullWidth:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage4.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage4.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="absolute top-0 right-0 p-10 px-16">
                        <paragraph
                            class="pl-3 md:text-3xl font-bold"
                            :options="{
                                color: 'text-white',
                            }"
                        >
                            <span
                                v-html="currentPage.content.sSubTitleTwo.text"
                            ></span>
                        </paragraph>
                    </div>
                    <hotspot-richmedia
                        :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Barrage de Petit-Saut (Guyane)-Abaissement et renforcement du seuil oxygénant'
                                    ),
                                }"
                        class="top-2 right-2"
                    />
                </div>
                <div class="container-components mb-4 lg:mb-8">
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-allports',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#0e498a', '#064e8d', '#0264a7'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphFour_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                class="text-nandor 2xl:text-lg"
                                v-html="
                                    currentPage.content.sParagraphFour_Content
                                        .text
                                "
                            ></span>
                            <Dots
                                :options="{
                                    colors: ['#0e498a', '#064e8d', '#0264a7'],
                                }"
                            />
                        </paragraph>
                    </div>
                    <div class="card relative">
                        <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Chantier de Petit-Saut en Guyane, témoignage de Claire Perot'
                                ),
                            }"
                            class="top-0 right-2"
                        />
                        <article-note style="margin-top: 0; margin-bottom: 1.25rem;overflow: initial;"
                            :options="{
                                verticalcontent:
                                    currentPage.content.sParagraphFive_Title
                                        .text,
                                content:
                                    currentPage.content.sParagraphFive_Quote
                                        .text,
                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-4xl xl:text-2xl',
                                    content: '',
                                },
                                margin: {},
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage5.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage5.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                       
                    </div>
                </div>
                <div class="card relative mb-4 lg:mb-8">
                    <image-with-descriptions
                        :options="{
                            imageFullWidth:
                                'pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.oImage6.src,
                            descriptions: [
                                {
                                    text: currentPage.images.oImage6.alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: currentPage.images.oImage6.text,
                                    position: 'top-left', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                            ],
                        }"
                    />

                    <div
                        class="
                            absolute
                            top-0
                            left-0
                            w-full
                            xl:w-1/2
                            p-5
                            2xl:p-14
                        "
                    >
                        <paragraph
                            class="pl-5 pt-7 md:text-3xl font-bold"
                            :options="{
                                color: 'text-white',
                            }"
                        >
                            <span
                                v-html="currentPage.content.sSubTitleThree.text"
                            ></span>
                        </paragraph>
                        <TimelineTitle
                            class="text-sm xl:text-lg"
                            :options="{
                                title: currentPage.content.sParagraphSix_Title
                                    .text,
                                content:
                                    currentPage.content.sParagraphSix_Content
                                        .text,
                                fontSize: {
                                    title: 'text-base xl:text-lg',
                                    content: 'text-md md:text-base lg:text-lg',
                                },
                                color: {
                                    title: 'text-white',
                                    content: 'text-white',
                                },
                            }"
                        >
                        </TimelineTitle>
                    </div>
                </div>
                <div class="card relative mb-4 lg:mb-8">
                    <div class="relative">
                            <hotspot-richmedia
                                :options=
                                        "{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            'Une centrale électrique sous la Mer de glace à Chamonix'
                                        ),
                                    }"

                                class="bottom-2 left-2"
                            />

                        <image-with-descriptions
                            style=""
                            :options="{
                                imageFullWidth:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage7.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage7.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>

                    <div
                        class="
                            absolute
                            top-0
                            left-0
                            w-full
                            xl:w-1/2
                            p-5
                            2xl:p-14
                        "
                    >
                        
                        <paragraph
                            class="pl-5 md:text-3xl font-bold"
                            :options="{
                                color: 'text-white',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphSeven_Title
                                        .text
                                "
                            ></span>
                        </paragraph>
                        <TimelineTitle
                            class="text-sm xl:text-lg"
                            :options="{
                                content:
                                    currentPage.content.sParagraphSeven_Content
                                        .text,
                                fontSize: {
                                    content: 'text-md md:text-base lg:text-lg',
                                },
                                color: {
                                    content: 'text-white',
                                },
                            }"
                        >
                        </TimelineTitle>
                    </div>
                </div>
                <div class="container-components">
                    <div class="card">
                        
                        <TitleParagraph
                            :options="{
                                from: 'from-allports',
                                to: 'to-resolution_blue',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#0e498a', '#064e8d', '#0264a7'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphEight_Title
                                        .text
                                "
                            >
                            </span>
                            
                        </TitleParagraph>

                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphEight_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card">
                        <article-note style="margin: 0;"
                            :options="{
                                verticalcontent:
                                    currentPage.content.sParagraphNine_Title
                                        .text,
                                content:
                                    currentPage.content.sParagraphNine_Quote
                                        .text,
                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-4xl lg:text-3xl',
                                    content: '',
                                },
                                margin: {},
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage8.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage8.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                        <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    `Aménagement Des Bois (Chamonix) - Captage sous glaciaire`
                                ),
                            }"
                            class="
                                top-8
                                right-2
                            "
                        />
                    </div>
                    <div class="card">
                        <div class="relative break-inside-avoid">
                            <image-with-descriptions
                                class="mb-4 mt-0 lg:mb-8"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage9.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage9
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                         {
                                            text: currentPage.images.oImage9
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Le réseau “Lacs sentinelles”'
                                    ),
                                }"
                                class="top-2 right-16"
                            />
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Emissions RCF -  Lacs Sentinelles'
                                    ),
                                }"
                                class="top-2 right-2"
                            />
                            <TitleParagraph
                                :options="{
                                    from: 'from-resolution_blue',
                                    to: 'to-allports',
                                }"
                            >
                                <span
                                    v-html="
                                        currentPage.content.sParagraphTen_Title
                                            .text
                                    "
                                ></span>
                                <Triangles
                                    :options="{
                                        colors: [
                                            '#0e498a',
                                            '#064e8d',
                                            '#0264a7',
                                        ],
                                        direction: 'top',
                                    }"
                                />
                            </TitleParagraph>
                        </div>

                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                class="text-nandor 2xl:text-lg"
                                v-html="
                                    currentPage.content.sParagraphTen_Content
                                        .text
                                "
                            ></span>
                            <!-- <square
                                :options="{
                                    from: 'from-allports',
                                    to: 'to-resolution_blue',
                                }"
                            /> -->
                        </paragraph>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";
import ParagraphFirstLetterBig from "../../components/ParagraphFirstLetterBig.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
        ParagraphFirstLetterBig,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
</style>
